import PlanboardMode from './PlanboardMode'
import PlanboardModeChooseDeal from '@/components/planboard/PlanboardModeChooseDeal'
import Planner from '@/components/planboard/Planner'

export default class PlanboardModeEditBooking extends PlanboardMode {
  constructor(planboard) {
    super(planboard)
    this.planner = new Planner(
      this,
      this.planboard.$elm.find('#planboard-booking-product-selector'),
    )
  }

  finish() {
    // 09/10/2019 PF:
    // I couldn't find $bookingProductSelector anywhere, but I am afraid to break something if I remove this
    // So I simply disabled the lint error for this line for now...
    // eslint-disable-next-line no-undef
    var $form = $bookingProductSelector
    $form.submit()
  }

  start() {
    this.showPlanner()
  }

  stop() {
    this.hidePlanner()
  }

  onChoosePackage() {
    PlanboardModeChooseDeal.prototype.onChoosePackage.apply(this, arguments)
  }
}
